import CryptoJS from "crypto-js";
export const generateHMAC = (email) => {
  const secretKey = "-lSX0WgJ8zOgpbDxRZa9jgqnOBxayytIX2hdmfuK";
  const userIdentifier = email;
  const hash = CryptoJS.HmacSHA256(userIdentifier, secretKey).toString(
    CryptoJS.enc.Hex
  );
  return hash;
};
